import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { Container, Icon } from '@components/gassan-ui'
import { useLoyaltyStatus } from './hooks/use-loyalty-status'

type MembershipExclusiveSectionTitleProps = {
  variant?: 'homepage' | 'exclusive'
}

export const MembershipExclusiveSectionTitle: FC<MembershipExclusiveSectionTitleProps> = ({
  variant = 'exclusive',
}) => {
  const { membershipName, isNoPremiumMember } = useLoyaltyStatus()
  const { t } = useTranslation('other')
  const isHomepage = variant === 'homepage'

  if (isNoPremiumMember) {
    return null
  }

  return (
    <Container className="flex flex-col items-center gap-2 lg:gap-4">
      <div className="relative grid w-full max-w-[280px] grid-cols-[1fr_auto_1fr] gap-4">
        <span className="mt-[26px] block h-[1px] w-full bg-pampas" />
        <Icon icon="diamond-grey" size={60} />
        <span className="mt-[26px] block h-[1px] w-full bg-pampas" />
      </div>
      <h4 className="w-full max-w-[400px] text-center font-special text-[10px] font-semibold uppercase tracking-[.25em] text-shade-500 md:text-[14px] lg:text-[20px]">
        {isHomepage ? membershipName : `${t('exclusiveForMembersTitle')} ${membershipName}`}
      </h4>
    </Container>
  )
}
